var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuddha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.36 842.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#f1f2f0;}.cls-3{fill:#712b2a;}.cls-4{fill:#d48544;}.cls-5{fill:#f1c494;}.cls-6{fill:#e07740;}.cls-7{fill:#eeb26e;}.cls-8{fill:#dc7a46;}.cls-9{fill:#f2d5ab;}.cls-10{fill:#f8aa68;}.cls-11{fill:#f3c093;}.cls-12{fill:#ecb76a;}.cls-13{fill:#c65436;}.cls-14{fill:#cc663b;}.cls-15{fill:#eab58a;}.cls-16{fill:#e09e58;}.cls-17{fill:#c2603a;}.cls-18{fill:#ecb269;}.cls-19{fill:#da6f3c;}.cls-20{fill:#c56a43;}.cls-21{fill:#ce4b30;}.cls-22{fill:#cf8347;}.cls-23{fill:#f2b98c;}.cls-24{fill:#e47337;}.cls-25{fill:#5f202e;}.cls-26{fill:#752a36;}.cls-27{fill:#e07842;}.cls-28{fill:#cf5830;}.cls-29{fill:#e5af69;}.cls-30{fill:#672932;}.cls-31{fill:#7e2b2e;}.cls-32{fill:#462628;}.cls-33{fill:#712c30;}.cls-34{fill:#65292e;}.cls-35{fill:#36232b;}.cls-36{fill:#db9c5a;}.cls-37{fill:#562530;}.cls-38{fill:#322931;}.cls-39{fill:#332229;}.cls-40{fill:#46282d;}.cls-41{fill:#e2753c;}.cls-42{fill:#5c2c31;}.cls-43{fill:#7f3733;}.cls-44{fill:#913135;}.cls-45{fill:#863033;}.cls-46{fill:#502e36;}.cls-47{fill:#f7c27b;}.cls-48{fill:#7d2b3c;}.cls-49{fill:#f3c181;}.cls-50{fill:#452832;}.cls-51{fill:#572c30;}.cls-52{fill:#ec7f54;}.cls-53{fill:#e67f46;}.cls-54{fill:#f6c196;}.cls-55{fill:#fabcab;}.cls-56{fill:#e8af68;}.cls-57{fill:#d3ac81;}.cls-58{fill:#eab477;}.cls-59{fill:#ebb19b;}.cls-60{fill:#db783e;}.cls-61{fill:#e37c4d;}.cls-62{fill:#ebb566;}.cls-63{fill:#8c4648;}.cls-64{fill:#da8451;}.cls-65{fill:#913430;}.cls-66{fill:#f2c9a1;}.cls-67{fill:#ebb76c;}.cls-68{fill:#873238;}.cls-69{fill:#48140f;}.cls-70{fill:#cc7c54;}.cls-71{fill:#eed6a3;}.cls-72{fill:#e28b56;}.cls-73{fill:#eb9b57;}.cls-74{fill:#804127;}.cls-75{fill:#af7b5f;}.cls-76{fill:#f4bf7d;}.cls-77{fill:#a57651;}.cls-78{fill:#502512;}.cls-79{fill:#a2a1ac;}.cls-80{fill:#adaab6;}.cls-81{fill:#aba9b6;}.cls-82{fill:#d8d1d5;}.cls-83{fill:#bdb3b4;}.cls-84{fill:#c5c2ca;}.cls-85{fill:#a5a3b0;}.cls-86{fill:#c7c4ce;}.cls-87{fill:#c2bcbe;}.cls-88{fill:#c3bec5;}.cls-89{fill:#dad4d9;}.cls-90{fill:#beb9be;}.cls-91{fill:#ddd3d7;}.cls-92{fill:#d6d2d5;}.cls-93{fill:#bab8bc;}.cls-94{fill:#cdc9cc;}.cls-95{fill:#c9c6ca;}.cls-96{fill:#d0ccce;}.cls-97{fill:#d7d2d6;}.cls-98{fill:#eae7e7;}.cls-99{fill:#e0d7d5;}.cls-100{fill:#ebeae8;}.cls-101{fill:#dad5d2;}.cls-102{fill:#b66d52;}.cls-103{fill:#fab493;}.cls-104{fill:#e77f70;}.cls-105{fill:#f6917b;}.cls-106{fill:#fccab7;}.cls-107{fill:#fdcca6;}.cls-108{fill:#cc8358;}.cls-109{fill:#de7651;}.cls-110{fill:#dd8364;}.cls-111{fill:#e88565;}.cls-112{fill:#f29a82;}.cls-113{fill:#fcc9a8;}.cls-114{fill:#f9d0a5;}.cls-115{fill:#a87b51;}.cls-116{fill:#e88b5b;}.cls-117{fill:#d77948;}.cls-118{fill:#d5704d;}.cls-119{fill:#e28668;}.cls-120{fill:#edab89;}.cls-121{fill:#fbc09c;}.cls-122{fill:#f2c09a;}.cls-123{fill:#fdd3b6;}.cls-124{fill:#f0ae81;}.cls-125{fill:#fcc7a6;}.cls-126{fill:#fbbfa9;}.cls-127{fill:#d19c70;}.cls-128{fill:#e6917e;}.cls-129{fill:#f4c29d;}.cls-130{fill:#fbc2a2;}.cls-131{fill:#fcc399;}.cls-132{fill:#fcc5a1;}.cls-133{fill:#ffd8ab;}.cls-134{fill:#efaf7c;}.cls-135{fill:#e7896a;}.cls-136{fill:#eaac80;}.cls-137{fill:#d27656;}.cls-138{fill:#d07647;}.cls-139{fill:#d97c52;}.cls-140{fill:#c16555;}.cls-141{fill:#c16c4c;}.cls-142{fill:#b06a4b;}.cls-143{fill:#d5794d;}.cls-144{fill:#be6a62;}.cls-145{fill:#bb6d5e;}.cls-146{fill:#a6564f;}.cls-147{fill:#b86655;}.cls-148{fill:#ce7558;}.cls-149{fill:#c77c6d;}.cls-150{fill:#b86d5e;}.cls-151{fill:#b06558;}.cls-152{fill:#b76e5b;}.cls-153{fill:#de8366;}.cls-154{fill:#d77565;}.cls-155{fill:#a85e53;}.cls-156{fill:#bd6f63;}.cls-157{fill:#bf7162;}.cls-158{fill:#b66a63;}.cls-159{fill:#9f514c;}.cls-160{fill:#b26859;}.cls-161{fill:#d6ced4;}.cls-162{fill:#fccdb4;}.cls-163{fill:#eabda8;}.cls-164{fill:#f1bb8f;}.cls-165{fill:#db9c57;}.cls-166{fill:#f2e1ad;}.cls-167{fill:#f7d2a3;}.cls-168{fill:#ead6a7;}.cls-169{fill:#e9bd97;}.cls-170{fill:#ede4e0;}.cls-171{fill:#eee3e3;}.cls-172{fill:#f2d7ad;}.cls-173{fill:#f6d59f;}.cls-174{fill:#f0d5a9;}.cls-175{fill:#975552;}.cls-176{fill:#a14c39;}.cls-177{fill:#d5b199;}.cls-178{fill:#c37d5c;}.cls-179{fill:#dec288;}.cls-180{fill:#d6dac8;}.cls-181{fill:#be5932;}.cls-182{fill:#e99f6e;}.cls-183{fill:#dcdad2;}.cls-184{fill:#e5c794;}.cls-185{fill:#eadfca;}.cls-186{fill:#c45f36;}.cls-187{fill:#e3dcda;}.cls-188{fill:#efa875;}.cls-189{fill:#a5604f;}.cls-190{fill:#e3a95c;}.cls-191{fill:#e9ca93;}.cls-192{fill:#dda45a;}.cls-193{fill:#e59b69;}.cls-194{fill:#e1dcd9;}.cls-195{fill:#ebdac8;}.cls-196{fill:#94594c;}.cls-197{fill:#d4994e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 595.36,
    height: 842.31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.44 299.27 273.73 275.2 251.25 285.98 179.94 316.47 174.44 299.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "190.26 335.96 283.13 276.57 255.15 306.27 201.04 349.26 190.26 335.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.77 258.46 170.77 276.57 273.73 269.69 251.71 265.8 170.77 258.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.17 220.62 174.44 237.9 248.35 256.09 249.73 252.42 180.17 220.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "190.26 201.82 256.3 243.1 258.29 239.73 200.5 186.99 190.26 201.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.48 172.62 267 232.85 270.82 229.95 231.69 162.53 215.48 172.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "248.5 153.06 268.07 148.32 285.04 226.43 281.83 228.57 248.5 153.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "263.75 309.02 256.07 319.91 216.4 363.82 230.5 375.52 238.19 361.64 267.54 312.46 263.75 309.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.56 320.25 260.08 364.39 274.87 368.41 283.13 325.3 275.56 320.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.46 310.97 333.46 358.43 317.52 362.56 310.53 314.75 315.46 310.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "325.2 309.71 360.86 374.25 377.71 365.2 329.22 307.3 325.2 309.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.92 299.16 393.08 350.52 402.94 336.31 329.45 291.13 333.92 299.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "411.08 316.36 416.46 299.39 334.61 277.83 334.61 284.48 411.08 316.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "419.68 260.87 419.68 278.98 324.29 269.92 324.29 265.57 419.68 260.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "342.29 252.27 344.35 257.77 416.46 240.46 411.08 222.8 342.29 252.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "334.03 239.66 336.78 243.32 403.05 203.88 391.59 188.45 334.03 239.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "322.11 229.45 326.46 233.01 376.34 173.5 361.09 163.07 322.11 229.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.01 148.32 343.43 153.32 313.39 226.24 308.81 223.95 326.01 148.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "285.99 144.15 305.02 144.15 299.75 228.08 292.64 228.08 285.99 144.15"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.38,331.72l1.38,19.95c7.79,7.11,17.34,16.84,25.13,23.94C291.64,361.86,281.64,345.48,273.38,331.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219,370.7,274.3,345l.46,6.67,1.62,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.12,425.16c2.29-10.13,4.08-20.26,6.38-30.38L217.32,373l46.31,1.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.22 374.48 298.15 430.55 284.39 375.06 264.22 374.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.78 408.14 298.15 430.55 263.91 373.97 217.78 408.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "216.75 488.45 217.78 408.14 247.15 416.33 216.75 488.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "175.28 493.19 195.26 424.69 217.78 408.14 217.47 432.35 175.28 493.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "194.62 464.6 194.62 492.41 216.75 491.66 217.47 432.35 194.62 464.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "172.53 512.14 186.75 535.83 249.73 468.42 216.75 488.45 216.75 491.66 195.46 491.66 172.53 512.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "355.81 413.01 379.66 488.45 387.46 387.32 373.7 372.99 355.81 413.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.27 496.47 373.7 372.99 352.15 359.58 320.27 496.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "387.46 387.32 401.9 455.43 418.64 499.22 418.64 538.2 379.66 488.45 387.46 387.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "327.73 560.33 359.92 528.46 357.65 515.04 379.16 486.87 418.64 538.2 417.5 588.65 372.39 550.33 327.73 560.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "357.65 515.04 338.62 539.12 401.45 541.87 357.65 515.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "359.92 540.05 417.5 587.5 401.45 541.87 359.92 540.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "114.13 600.34 200.58 555.4 185.22 593.24 114.13 600.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "199.43 555.4 228.55 540.05 255.84 553.34 185.22 593.24 199.43 555.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "112.99 600.34 101.98 633.59 185.22 593.24 112.99 600.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "237.36 563.78 268.68 602.41 186.63 592.44 237.36 563.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "99.95 634.67 268.68 602.41 186.63 592.44 99.95 634.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "284.39 375.06 321.73 376.39 298.61 432.56 284.39 375.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "320.27 345 299.89 375.62 321.73 376.39 328.15 362.18 320.27 345"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "320.27 345 327.75 361.31 331.66 351.32 320.27 345"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "331.66 351.32 352.15 359.58 298.95 431.73 331.66 351.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "230.31 530.64 242.08 530.64 333.41 440.04 352.15 359.58 281.18 452.98 231.95 497.62 230.31 530.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "186.75 535.83 209.22 531.86 276.94 474.99 194.78 527.24 186.75 535.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "194.78 527.24 249.34 468.65 249.73 492.3 194.78 527.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "320.27 496.47 338.62 539.12 379.16 486.87 320.27 496.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "355.81 414.33 320.27 496.47 379.16 486.87 355.81 414.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "145.26 626.01 175.28 631.53 238.26 670.97 251.1 641.62 176.82 619.97 145.26 626.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "318.67 612.57 329.98 623.43 414.36 621.44 417.5 587.5 412.15 583.09 318.67 612.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "297.68 591.63 318.67 612.57 361.27 599.14 322.95 583.83 297.68 591.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "322.95 583.83 342.21 578.48 378.53 555.39 412.15 583.09 361.27 599.14 322.95 583.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "327.73 560.33 342.63 578.67 378.53 555.39 372.15 550.13 327.73 560.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "412.68 621.48 414.06 633.36 421.39 629.47 480.1 619.97 478.26 596.45 418.64 561.59 417.5 588.65 414.36 621.44 412.68 621.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "478.26 596.45 491.1 617.2 480.1 619.97 478.26 596.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "329.98 623.43 351.38 669.44 414.06 633.36 412.68 621.48 329.98 623.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "199.64 533.55 200.58 555.4 228.55 540.05 255.84 553.34 322.95 583.83 342.21 578.48 327.73 560.33 348.7 539.56 338.62 539.12 320.27 496.47 261.57 531.33 230.31 530.64 231.16 513.43 209.22 531.86 199.64 533.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "175.28 493.19 170.69 509.39 172.53 512.14 194.62 492.41 194.62 465.3 175.28 493.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "236.81 440.85 249.34 468.65 216.75 491.66 216.1 487.83 236.81 440.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "247.15 416.33 236.56 441.42 248.83 469.02 279.63 455.88 298.15 430.55 247.15 416.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "333.34 440.34 320.27 496.47 261.57 531.33 241.32 530.88 333.34 440.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "176.82 619.97 268.68 602.41 275.71 606.31 257.37 628.01 251.1 641.62 176.82 619.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "273.38 331.72 320.88 331.22 320.27 345 299.89 375.62 273.38 331.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M217.15,373.22c.63-.87,1.26-1.65,1.89-2.52l57.34-17.56c7.9,7.46,15.61,15,23.51,22.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "237.36 563.78 255.84 553.34 322.95 583.83 275.56 606.31 268.36 602.37 237.36 563.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M249,451.76q.39,20.26.77,40.54l15.15-9.64a18.19,18.19,0,0,1-2.31-9.35c.4-11.31,12.07-17.38,12.65-17.67q-.68-5.92-1.34-11.83l-8.71,1.53Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M333.29,292.67l6.11-6.2a2.91,2.91,0,0,1,2.14-.07c2.22.94,2.38,5.54,2,8.41-.56,4.2-2.36,5.31-4.59,10.54a51.53,51.53,0,0,0-2.75,9.63c-1.8,8-2.7,12-2.14,16.36.61,4.76,2.54,9.53,1.07,13.76a3.23,3.23,0,0,1-1.68,2.14c-1.6.58-3.58-1.21-4.43-2-4.69-4.25-6.08-15.28-6.44-18.77l3.1-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M251.13,285.71a11.17,11.17,0,0,0-3.24,5.69,11.41,11.41,0,0,0,.92,6.73c2,4.76,6.6,15.67,8.47,22.89,1,4,4.4,19.08,3.61,25.6-.06.44-.26,2,.45,2.41,1.35.84,5-2.77,5.28-3.09,1.67-1.7,5.43-5.9,5.37-15.5-.4-.53-1.08-1.25-1.48-1.78q-6.12-16.49-12.22-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M255.37,314.83a19.8,19.8,0,0,1,7.35,4.62,20,20,0,0,1,5.5,10.66c.32,1.82,1.76,10-3,13.53a8.14,8.14,0,0,1-4.25,1.49,68.39,68.39,0,0,0-5.62-30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M325.85,322.11c3.65-2.67,6.89-5.33,10.54-8a115.84,115.84,0,0,0-2.14,14.75c-.64,6.17-.53,9.29.36,11.24a4.69,4.69,0,0,1,.45,3c-.35,1.56-1.78,3-3.09,3.09-1.82.08-4.11-2.54-4.24-6.76Q326.79,330.77,325.85,322.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M258.29,295.68l10.39-22.62a26.82,26.82,0,0,1,11.77-1.84,27.53,27.53,0,0,1,15.9,6.73,24,24,0,0,1,8.41-5.81c9.25-3.76,17.86-.27,19.87.61l9,20c-2.6,9.73-5.66,19.54-8.26,29.27a83.93,83.93,0,0,1-13.6,17.7c-5.26,5.08-9.4,8.19-13.91,8.06-5.35-.15-8.55-2.56-14.14-6.5a53.34,53.34,0,0,1-12.92-12.69C266.75,317.63,262.36,306.68,258.29,295.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M267.92,295.07l5.34-6.34,9.81-.25,7,6.09q.66,8.08,1.3,16.17c.05,1.6.1,3.21.16,4.81l-5.75,1.92-.06-1.15L269.83,308a65.5,65.5,0,0,1-1.33-6.89C268.19,299,268,297,267.92,295.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M300.12,316.43l5.32,1L323.74,307q.93-3.23,1.78-6.72c.52-2.15,1-4.23,1.4-6.26l-6.33-4.83-9.46,1.4-3.8,1.23-3.57,5-1.6,4.29v10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M292.47,315.93c1.48.43,2.32,1.39,3.93,1.32a5.45,5.45,0,0,0,3.49-1.81,8.49,8.49,0,0,1,5.94,2,8.28,8.28,0,0,1,2.52,4.21l-6.19,8.48H291.54l-4.9-4.12-.85-8.56C289,315.52,291.08,315.52,292.47,315.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M285.79,317.47a6.38,6.38,0,0,1,8.23-1.63,6.15,6.15,0,0,1,2.56,5.75l-10,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M285.15,323.77l6.43,6.67,10.58-.29,5.16-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M305.44,317.46l2.91,4.21-6.19,8.48v2.14l3.09,8.49a48.58,48.58,0,0,0,8.77-9.49A58.15,58.15,0,0,0,323.74,307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M270,308.25l15.75,8.07.84,8.64,5,5.19.3,2.14L289,338.81a47.5,47.5,0,0,1-19-30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M291.84,332.29l-3.21,7.11a13.61,13.61,0,0,0,7.8,3.49,15.75,15.75,0,0,0,9.51-2.11l-3.78-8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M258.71,296.82l6.3-4.2,2.91,2.45a74.56,74.56,0,0,0,2.75,15.75,55.79,55.79,0,0,0,7.49,17.12,51.76,51.76,0,0,0,14.67,13.45,10.24,10.24,0,0,0,5.05,1.68,10.85,10.85,0,0,0,6.42-2.14c7.06-4.68,11.16-12.54,11.16-12.54,6.8-13,10.27-28.58,11.46-34.39-2.14-1.53-4.19-3.3-6.33-4.83.46-1.28.63-2.65,1.09-3.93,2.85,2.5,5.91,5.35,8.76,7.84l2.66-1.51.55,1.21Q329.84,307,326,321.29a85.47,85.47,0,0,1-14.1,18.42c-7.76,7.65-11.49,8.26-13,8.4-5,.47-8.93-2.13-14-5.54a56.66,56.66,0,0,1-14.4-13.91Q264.6,312.75,258.71,296.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M268.68,273.06c.26,4.89.52,10.05.78,14.94L265,292.62l-6.3,4.2-.42-1.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "282.86 288.8 289.47 294.46 290.08 296.82 293.1 296.82 292.38 289.87 285.48 284.94 282.86 288.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "315.38 298.05 309.19 290.88 320.59 289.17 320.59 297 317.37 297.9 315.38 298.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M292.78,293.77l6.91-.23a51,51,0,0,0,5.13-4.2c1.34-1.26,2.52-2.49,3.55-3.67q0-7.47,0-14.94a27.11,27.11,0,0,0-12,7.22,20.26,20.26,0,0,0-4.74-3.67,20.81,20.81,0,0,0-7-2.41l.9,13.07,6.9,4.93C292.51,291.17,292.65,292.47,292.78,293.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "299.69 293.54 303.76 296.82 307.33 291.8 311.13 290.57 310.26 283.61 305.44 288.5 299.69 293.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M258.29,295.68l-7-9.56a40.47,40.47,0,0,1,26.14-49.53,25.77,25.77,0,0,1,3.06-11.31,26.15,26.15,0,0,1,11.31-10.85,40.6,40.6,0,0,0-1.07-5.51c-.79-2.95-1.39-3.81-1.38-5.35s.63-3.73,3.52-6.42q1.46-19.34,2.9-38.67,2.07,19.34,4.13,38.67a8.74,8.74,0,0,1,3.36,5.35c.3,1.82-.26,3.43-1.37,6.58a47.06,47.06,0,0,1-2.3,5.35,26.41,26.41,0,0,1,9,7.79,26.88,26.88,0,0,1,5.05,15,41.85,41.85,0,0,1,26.14,49.38l-6.11,6.2-9-20a24.5,24.5,0,0,0-28.28,5.2,26.69,26.69,0,0,0-27.67-4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M267.92,295.07l5.34-6-.22-4.81-8,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M315.38,270.41l6.5,15.18,8.56,7.49,2.66-1.51-8.47-18.82a16.92,16.92,0,0,0-9.25-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M310.26,283.61l10.81.1.67,1.56a12.61,12.61,0,0,1-1.15,3.9l-9.46,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M268.68,273.06a26.57,26.57,0,0,1,9.59-1.9,26.87,26.87,0,0,1,6.31.71l.9,13.07L273,284.22l-3.7,3.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "273.26 289.02 282.86 288.8 285.48 284.94 273.04 284.22 273.26 289.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M308.35,271v14.55l1.91-2,10.81.1-5.69-13.3a18,18,0,0,0-3.7,0A18.89,18.89,0,0,0,308.35,271Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "291.84 332.29 302.16 332.29 302.16 330.15 291.54 330.15 291.84 332.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M290.08,296.82h3v18.35l3.33,1.71,2.82-1.86.44-21.48,4.07,3.28-1.6,4.29v11.23a2.23,2.23,0,0,1,2.06,1.38,2,2,0,0,1-.32,2.07c-.53.53-1.28.38-2.43.45a10.5,10.5,0,0,0-3.59.92c-.43,1.48-.87,2.95-1.3,4.43l-1.38-4.43a12.53,12.53,0,0,0-3.05-.74c-1.6-.17-2.46.05-3-.56a2.06,2.06,0,0,1-.08-2.14,2.55,2.55,0,0,1,2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M273.65,297.87l-1.75-7.3,1.36-1.54,9.6-.23.28,8.72-3.59,1a12.45,12.45,0,0,1-4.28-.15A11.64,11.64,0,0,1,273.65,297.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M269.83,296.9a5.77,5.77,0,0,0,1.91,2.07,6.13,6.13,0,0,0,2.75.92c3.81.43,5.62-1,8.71-.77a10.32,10.32,0,0,1,4.74,1.68,5.72,5.72,0,0,0-3.13-3.07c-1.15-.41-2.5-.19-5.2.24-2,.33-2.82.65-4.28.39-.62-.11-.83-.24-2.14-.61S270.6,297.07,269.83,296.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M322.87,296.45a5.94,5.94,0,0,1-1.91,2.06,6.17,6.17,0,0,1-2.75.92c-3.82.43-5.62-1-8.72-.77a10.36,10.36,0,0,0-4.74,1.68,5.79,5.79,0,0,1,3.14-3.07c1.25-.45,2.2-.12,5.2.25,1.8.22,3.29.32,4.28.38.69-.21,1.41-.42,2.14-.61C320.66,297,321.78,296.7,322.87,296.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M286.34,323.43c.1-.32,1.74.47,3.67-.31,1.12-.45,1-.9,2.21-1.37.37-.15,2.38-.94,3.69.1a2.58,2.58,0,0,1,.82,1.19,2.35,2.35,0,0,1,.84-1.6c1.35-1,3.84.3,4.59.69a13.17,13.17,0,0,0,2.06,1.14,6.1,6.1,0,0,0,2.75.27,4.61,4.61,0,0,1-2.37,1.35c-1.85.35-3-.83-4.85-.32a4.13,4.13,0,0,0-1.72,1h-2.37a4.19,4.19,0,0,0-2.33-1.07c-1.27-.12-1.76.54-3.06.65C288.14,325.32,286.22,323.79,286.34,323.43Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "595.28 827.58 554.85 803.5 507.38 842.31 595.37 842.31 595.28 827.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "554.85 803.5 595.37 770.71 595.28 827.58 554.85 803.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "534.9 752.6 556.45 738.15 595.28 725.31 595.28 769.34 534.9 752.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "496.83 780.12 534.9 752.6 595.28 769.34 595.37 770.71 548.8 808.45 496.83 780.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "436.87 776.04 474.29 707.04 516.78 701.54 595.37 672.8 595.37 718.36 518.92 709.18 459 767.88 436.87 776.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "546.13 711.78 552.1 741.07 556.45 738.15 595.28 725.31 595.37 718.36 546.13 711.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "554.35 687.82 574.89 663.27 595.37 648.65 595.37 672.8 554.35 687.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "473.68 708.18 498.75 644.06 575.11 663.33 554.85 687.87 516.78 701.54 473.68 708.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "328.77 820.05 349.85 842.31 507.38 842.31 548.8 808.45 496.83 780.12 481.62 789.59 415.59 819.55 328.77 820.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "311.64 806.1 270.06 842.31 349.85 842.31 329.04 820.24 311.64 806.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "256.91 819.55 285.63 798.79 294.49 808.79 307.66 803.04 311.64 806.1 280.1 833.57 274.03 817.39 256.91 822.61 256.91 819.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "0 842.31 0 833.57 89.98 833.57 173.75 817.39 201.27 833.57 256.91 822.61 274.03 817.39 280.1 833.57 270.06 842.31 0 842.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "173.75 817.39 256.91 819.55 256.91 822.61 201.27 833.57 173.75 817.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "34.03 754.13 0 793.57 0 833.57 89.98 833.57 34.03 754.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "34.03 754.13 116.89 799.99 89.98 833.57 34.03 754.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "0 731.81 0 793.57 34.03 754.13 0 731.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "37.36 648.96 34.03 754.13 69.38 773.69 143.18 752.6 116.89 699.71 37.36 648.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "0 656.6 37.36 648.96 34.03 754.13 0 731.81 0 656.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "37.36 648.96 91.89 638.18 116.89 699.71 37.36 648.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "0 646.2 0 656.6 13.87 653.76 0 646.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "0 623.88 0 646.2 13.87 653.76 0 623.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "0.02 597.48 0 624.49 13.87 653.76 36.14 649.21 0.02 597.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "0 577.57 0 598.05 35.95 649.24 91.89 638.18 0 577.57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-102",
    cx: 296.71,
    cy: 201.76,
    r: 3.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 289.15,
    cy: 219.99,
    r: 2.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 261.75,
    cy: 276.86,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 260.77,
    cy: 269.01,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 260.77,
    cy: 262.01,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 260.77,
    cy: 255.85,
    r: 2.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-108",
    cx: 296.57,
    cy: 272.13,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-109",
    cx: 287.94,
    cy: 267.97,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-110",
    cx: 280.49,
    cy: 266.94,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-111",
    cx: 273.61,
    cy: 266.94,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 267.02,
    cy: 269.41,
    r: 2.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-113",
    cx: 266.96,
    cy: 262.82,
    r: 2.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 267.31,
    cy: 256.51,
    r: 2.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-115",
    cx: 267.02,
    cy: 249.57,
    r: 2.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 303.65,
    cy: 268.09,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-117",
    cx: 296.57,
    cy: 264.33,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 287.94,
    cy: 260.18,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 280.09,
    cy: 260.24,
    r: 2.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 273.04,
    cy: 260.98,
    r: 2.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-121",
    cx: 273.84,
    cy: 254.22,
    r: 2.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 273.84,
    cy: 247.68,
    r: 2.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 274.64,
    cy: 241.83,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 296.57,
    cy: 256.54,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 280.49,
    cy: 253.49,
    r: 2.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-126",
    cx: 283.3,
    cy: 222.52,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-127",
    cx: 281.09,
    cy: 228,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128",
    cx: 280.61,
    cy: 233.59,
    r: 2.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-129",
    cx: 280.35,
    cy: 240.72,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 280.63,
    cy: 247.43,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-131",
    cx: 287.8,
    cy: 243.93,
    r: 2.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 288.54,
    cy: 251.84,
    r: 3.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 296.05,
    cy: 248.23,
    r: 2.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 296.23,
    cy: 240.26,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 287.8,
    cy: 235.67,
    r: 2.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 288.09,
    cy: 227.47,
    r: 2.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 296.71,
    cy: 223.61,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 296.23,
    cy: 231.83,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-139",
    cx: 303.65,
    cy: 235.64,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 311.13,
    cy: 233.55,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 303.76,
    cy: 243.78,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 303.51,
    cy: 251.49,
    r: 2.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 304.02,
    cy: 259.46,
    r: 2.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-144",
    cx: 310.64,
    cy: 240.52,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 310.83,
    cy: 246.96,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-146",
    cx: 310.83,
    cy: 253.98,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-147",
    cx: 311.18,
    cy: 260.14,
    r: 2.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 311.13,
    cy: 267.09,
    r: 2.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 317.67,
    cy: 240.51,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 318.32,
    cy: 246.96,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-151",
    cx: 317.87,
    cy: 254.29,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 318.1,
    cy: 261.17,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-153",
    cx: 318.1,
    cy: 267.48,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-154",
    cx: 325.17,
    cy: 248.22,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 324.61,
    cy: 255.31,
    r: 2.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-156",
    cx: 324.43,
    cy: 261.89,
    r: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-157",
    cx: 324.76,
    cy: 268.45,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-158",
    cx: 331.82,
    cy: 261.59,
    r: 2.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-159",
    cx: 331.49,
    cy: 268.61,
    r: 2.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-160",
    cx: 332.01,
    cy: 275.46,
    r: 2.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "37.36 755.97 49.93 746.79 78.67 768.34 174.84 818.03 88.32 834.08 116.89 799.99 37.36 755.97"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M269.22,572.77a4.46,4.46,0,0,0-4.21.4,3.64,3.64,0,0,0-1.26,2c1.72,0,4,.42,5.71.46C269.46,574.77,269.22,573.57,269.22,572.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M269.94,577.41c-.22-.1-3.64-1.64-6.3.23a5.27,5.27,0,0,0-1.72,2.07l8.25,1.49C270.1,579.94,270,578.68,269.94,577.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M313.28,573.78c-2.18-3.44-4.59-7.6-6.76-11l10.09-7.57A33.06,33.06,0,0,1,323,557c12.74,5.09,17.43,16.75,19.6,21.67a112.47,112.47,0,0,0-11.42-3.09C324.65,574.25,318.77,574.2,313.28,573.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M281.41,574.39a101,101,0,0,1,10.09-5,89.94,89.94,0,0,1,15.88-5.28c2.09,3.16,4.5,6.47,6.59,9.64a33.17,33.17,0,0,0-10.78,2.14,34.76,34.76,0,0,0-10.55,5.5,11.77,11.77,0,0,0-4-4.67A12.44,12.44,0,0,0,281.41,574.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M316.61,555.17a19.55,19.55,0,0,0-10.44.12,17.88,17.88,0,0,0-3.55,1.49,48.57,48.57,0,0,1-8.72,0A49.48,49.48,0,0,1,286,555.4a8.83,8.83,0,0,0,1.26,4.13,10,10,0,0,0,5.39,3.9c5.9,2.21,11.9.09,13.88-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M268,564.11q1.1,8.55,2.18,17.09l16.4,12,56.06-14.56a100,100,0,0,0-13.18-3.44c-5.61-1.07-10.66-2-16.4-1.61A42,42,0,0,0,292.64,581a13.53,13.53,0,0,0-6.76-5.85,12.53,12.53,0,0,0-4-.8,9.76,9.76,0,0,0-8-10.78l3.78,10.66-3.32-2.06a7.55,7.55,0,0,0-6.31-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M292.76,591.63,292.64,581a41.43,41.43,0,0,1,19.16-7.22,39.81,39.81,0,0,1,9.28.1l.48,10.3Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "309.27 501.06 291.73 507.25 271.2 528.8 281.87 538.89 309.27 501.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "281.87 538.89 288.98 542.22 301.3 540.84 309.27 524.56 309.27 501.06 281.87 538.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "267.19 508.05 261.92 523.18 263.18 543.82 279.46 553.68 279.92 558.96 283.24 558.96 267.19 508.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "267.19 508.05 289.66 526.05 290.92 541.18 281.25 552.63 267.19 508.05"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M249,452.1c4.43-2.1,9.21-3.28,13.65-5.39,3.58-1.06,7.56-2,11.27-2.9a39.75,39.75,0,0,1-.5-9.82A60.34,60.34,0,0,1,275,423.78a7,7,0,0,0-4,1.15c-3,2.06-4.07,6.84-2.4,11.81-.77-2.41-1.53-4.82-2.3-7.22A35.14,35.14,0,0,0,268,418.17a10.39,10.39,0,0,0,4.36-8.14,10.27,10.27,0,0,0-3.67-7.69,32.76,32.76,0,0,1-1.72,9c-1.72,5-3.7,6.72-5,10.54-1,2.83-1.75,7.15-.23,13.3L259.05,432c.08-3.59.15-7.19.23-10.78a13.49,13.49,0,0,0,2.75-6.65c.74-6.3-3.47-10.79-4.13-11.46q-1.36,7.11-2.75,14.21a31.31,31.31,0,0,0-.57,21.44L251.14,433h0a68.17,68.17,0,0,1,.69-9.52c.54-3.6,1-3.6,1.14-6a20.7,20.7,0,0,0-.91-7.68c-.66,1.5-1.54,3.61-2.41,6.19A60.37,60.37,0,0,0,246,433.64,43.46,43.46,0,0,0,249,452.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M264.73,482.75a17.56,17.56,0,0,1-1.23-15.17c4-9.65,13.72-15.49,15.73-16.4a41.74,41.74,0,0,1,1.95-16.62,9.32,9.32,0,0,1-2.75-1.72c-4-3.57-3.43-9.38-3.33-10.32a24,24,0,0,0,10.21,8.26q0,11.81.11,23.61l-7.68,20.07-2.69,1.72c-2,1.26-2.13,1.35-2.68,1.72a40.6,40.6,0,0,1-3.66,2.48C267.71,480.91,266.46,481.84,264.73,482.75Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "393.19 788.6 473.22 708.57 437.68 775.3 502.57 751.91 484.91 788.6 414.06 820.93 393.19 788.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "502.57 751.91 484.91 788.6 576.17 725.08 502.57 751.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "437.68 775.3 517.47 701.47 578.69 723.94 502.57 751.91 437.68 775.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "426.67 668.45 510.82 612.57 474.13 707.43 393.19 788.6 426.67 668.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "351.08 672.34 351.38 669.44 421.39 629.47 507.36 614.87 351.08 672.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "351.08 672.34 350.31 718.66 507.36 614.87 351.08 672.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "329.98 820.93 307.36 804.42 350.31 718.66 426.67 668.45 329.98 820.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "292.38 813.44 307.36 804.42 350.31 719.27 305.68 638.56 292.38 813.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "305.68 638.56 274.19 678.99 292.38 813.44 305.68 638.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "292.38 586.13 305.68 638.56 350.31 719.27 351.38 669.44 329.98 623.43 292.38 586.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "292.38 586.13 255.84 628.55 238.26 670.97 239.79 715.45 283.81 804.42 291.46 806.64 274.19 678.99 305.68 638.56 292.38 586.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "119.64 703.3 173.98 818.18 199.43 788.6 119.64 703.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "167.91 668.04 199.43 788.6 252.86 820.24 257.22 820.24 167.91 668.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "257.22 820.24 282.95 802.67 239.76 714.54 166.64 665.69 257.22 820.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "173.98 818.18 252.86 820.24 199.43 788.6 173.98 818.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "79.28 610.66 118.72 702.38 199.43 788.6 167.83 667.72 79.28 610.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "79.28 610.66 238.26 670.97 239.76 714.54 79.28 610.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "9.34 721.18 78.13 769.34 173.98 818.18 82.03 734.94 9.34 721.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "82.03 734.94 137.49 741.03 173.98 818.18 82.03 734.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "8.43 721.18 69.88 698.48 119.64 703.3 137.49 741.03 82.03 734.94 8.43 721.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "79.28 610.66 176.96 630.38 238.26 670.97 79.28 610.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "329.04 820.24 393.65 788.14 414.06 820.93 329.04 820.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "329.04 820.24 426.67 668.45 393.19 788.14 329.04 820.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuddha);
export default __webpack_public_path__ + "static/media/buddha.4152469c66f1e7501820a98879ba355c.svg";
export { ForwardRef as ReactComponent };